import { FC } from 'react';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertProps,
  AlertTitle,
  Fade,
} from '@chakra-ui/react';

type SuccessProps = AlertProps & {
  title: string;
  description?: string;
};

export const Success: FC<SuccessProps> = ({ title, description, ...props }) => {
  return (
    <Fade
      in
      transition={{
        enter: { duration: 0.4 },
        exit: { duration: 0.4 },
      }}
    >
      <Alert
        status="success"
        p={0}
        color="green.600"
        background="none"
        data-testid="success-message"
        {...props}
      >
        <AlertIcon />
        <AlertTitle fontWeight="semibold">{title}</AlertTitle>
        {description && (
          <AlertDescription pl={2}>{description}</AlertDescription>
        )}
      </Alert>
    </Fade>
  );
};
